module.exports = __webpack_public_path__ + "img/49.a31dda1.png";